import { render, staticRenderFns } from "./LegalIdentifier.vue?vue&type=template&id=90e87164"
import script from "./LegalIdentifier.vue?vue&type=script&lang=ts"
export * from "./LegalIdentifier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports